
import { hermioneBio, dumbledoreBio, harryBio } from './ronBios'
import { hermioneReviewerReviewHinge, dumbledoreReviewerReviewBumble, harryReviewerReviewTinder } from './ronReviewerReviews'

export const hermioneReviewerProfile = {
  _id: 'hermioneReviewerProfileId',
  userId: 'hermioneUserId',
  email: 'hermione@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-4-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...hermioneBio },
  profileReviews: [
    // { ...hermioneProfileReviewHinge }
  ],
  reviewerReviews: [
    { ...hermioneReviewerReviewHinge }
  ],
}

export const dumbledoreReviewerProfile = {
  _id: 'dumbledoreReviewerProfileId',
  userId: 'dumbledoreUserId',
  email: 'dumbledore@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-dumbledore-9-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: true,
  isHotty: false,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `Open AI gpt4o mini`,
  openAIAssistantID: `NA`,
  bio: { ...dumbledoreBio },
  profileReviews: [
    // { ...dumbledoreProfileReviewBumble }
  ],
  reviewerReviews: [
    { ...dumbledoreReviewerReviewBumble }
  ],
}

export const harryReviewerProfile = {
  _id: 'harryReviewerProfileId',
  userId: 'harryUserId',
  email: 'harry@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-5-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...harryBio },
  profileReviews: [
    // { ...harryProfileReviewTinder }
  ],
  reviewerReviews: [
    { ...harryReviewerReviewTinder }
  ],
}